import * as React from "react";
import type { SVGProps } from "react";
const SvgSmileyWink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.672 14.8c.7 1.13 1.929 1.88 3.328 1.88 1.4 0 2.628-.75 3.328-1.88M9.798 9H7.8m13.8 3a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0m-6.72-3h.085v.077h-.085z"
    />
  </svg>
);
export default SvgSmileyWink;
